// Mock data for EBR Systems & Services - Laptop Store

export const heroSlides = [
  {
    id: 1,
    title: "Expert Laptop Care",
    subtitle: "Professional Repair & Maintenance",
    description: "Trusted by thousands across India since 2007",
    cta: "Book Service Now",
    image: "https://images.unsplash.com/photo-1558478551-1a378f63328e"
  },
  {
    id: 2,
    title: "Premium Laptop Sales",
    subtitle: "All Top Brands Available",
    description: "HP, Dell, Lenovo, Apple, Asus & More",
    cta: "Explore Laptops",
    image: "https://images.pexels.com/photos/6372829/pexels-photo-6372829.jpeg"
  },
  {
    id: 3,
    title: "Genuine Spare Parts",
    subtitle: "Original Components Only",
    description: "Fast delivery and installation services",
    cta: "View Spares",
    image: "https://images.unsplash.com/photo-1721332154191-ba5f1534266e"
  }
];

export const services = [
  {
    id: 1,
    title: "Screen Replacement",
    description: "Cracked or damaged display? We replace all types of laptop screens with genuine parts. Quick turnaround time guaranteed.",
    icon: "Monitor"
  },
  {
    id: 2,
    title: "Battery Replacement",
    description: "Poor battery life? We stock original batteries for all major brands. Professional installation included.",
    icon: "Battery"
  },
  {
    id: 3,
    title: "Keyboard Repair",
    description: "Sticky or broken keys? Complete keyboard replacement and repair services for all laptop models.",
    icon: "Keyboard"
  },
  {
    id: 4,
    title: "Data Recovery",
    description: "Lost important files? Our experts can recover data from damaged hard drives and SSDs safely.",
    icon: "HardDrive"
  },
  {
    id: 5,
    title: "Hardware Upgrade",
    description: "Slow performance? Upgrade your RAM, SSD, or other components for better speed and efficiency.",
    icon: "Cpu"
  },
  {
    id: 6,
    title: "Virus Removal",
    description: "System infected? Complete malware removal and system optimization to keep your laptop secure.",
    icon: "Shield"
  }
];

export const stats = [
  {
    id: 1,
    number: "150+",
    label: "Expert Technicians",
    icon: "Users"
  },
  {
    id: 2,
    number: "35+",
    label: "Service Centers",
    icon: "MapPin"
  },
  {
    id: 3,
    number: "500K+",
    label: "Happy Customers",
    icon: "ThumbsUp"
  },
  {
    id: 4,
    number: "18+",
    label: "Years Experience",
    icon: "Award"
  }
];

export const laptopBrands = [
  {
    id: 1,
    name: "HP Laptops",
    description: "Premium business and personal laptops with cutting-edge technology",
    image: "https://images.unsplash.com/photo-1619606619096-c759b30552bd",
    popular: true
  },
  {
    id: 2,
    name: "Dell Laptops",
    description: "Reliable performance laptops for professionals and students",
    image: "https://images.unsplash.com/photo-1520607162513-77705c0f0d4a",
    popular: true
  },
  {
    id: 3,
    name: "Lenovo Laptops",
    description: "Innovative designs with powerful performance capabilities",
    image: "https://images.pexels.com/photos/7382386/pexels-photo-7382386.jpeg",
    popular: false
  },
  {
    id: 4,
    name: "Apple MacBook",
    description: "Premium MacBook Pro and Air models for creative professionals",
    image: "https://images.unsplash.com/photo-1575491825092-7431433a2cbd",
    popular: true
  },
  {
    id: 5,
    name: "Asus Laptops",
    description: "Gaming and productivity laptops with advanced features",
    image: "https://images.unsplash.com/photo-1453928582365-b6ad33cbcf64",
    popular: false
  },
  {
    id: 6,
    name: "Acer Laptops",
    description: "Affordable and powerful laptops for everyday computing",
    image: "https://images.pexels.com/photos/274025/pexels-photo-274025.jpeg",
    popular: false
  }
];

export const spareCategories = [
  "Display Panels",
  "Keyboards",
  "Batteries",
  "Adapters",
  "RAM Modules",
  "Storage Drives",
  "Cooling Fans",
  "Motherboards",
  "Touchpads",
  "Hinges",
  "Speakers",
  "Webcams"
];

export const cities = [
  { name: "Chennai", branches: 8 },
  { name: "Bangalore", branches: 12 },
  { name: "Mumbai", branches: 10 },
  { name: "Pune", branches: 6 },
  { name: "Hyderabad", branches: 9 }
];

export const brandLogos = [
  { name: "HP", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/200px-HP_logo_2012.svg.png" },
  { name: "Dell", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/200px-Dell_Logo.svg.png" },
  { name: "Lenovo", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/200px-Lenovo_logo_2015.svg.png" },
  { name: "Apple", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Apple_logo_black.svg/200px-Apple_logo_black.svg.png" },
  { name: "Asus", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/ASUS_Logo.svg/200px-ASUS_Logo.svg.png" },
  { name: "Acer", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Acer_2011.svg/200px-Acer_2011.svg.png" },
  { name: "Sony", url: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Sony_logo.svg/200px-Sony_logo.svg.png" }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    location: "Chennai",
    rating: 5,
    text: "Excellent service! They fixed my laptop screen in just 2 hours. Very professional and affordable.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
  },
  {
    id: 2,
    name: "Priya Sharma",
    location: "Bangalore",
    rating: 5,
    text: "Best laptop store in the city. Bought a new Dell laptop with great discount and warranty support.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
  },
  {
    id: 3,
    name: "Amit Patel",
    location: "Mumbai",
    rating: 5,
    text: "Quick and reliable service. They recovered all my data from a crashed hard drive. Highly recommended!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
  }
];

export const contactInfo = {
  phone: "+91  97414 97228",
  alternatePhone: "+91 84319 60546",
  email: "support@ebrsystems.in",
  address: "EBR SYSTEMS AND SERVICES 2/25,1st main 1st cross Hanumanthpuram Srirampuram Bangalore 560021, 560021 Bangalore, Karnataka, India"
};
